<div class="modal-header">
  <h5 class="modal-title">Add Group</h5>
</div>
<div class="modal-body">
  <form [formGroup]="addForm">
    <div>
      <label class="form-label"
             for="name"
             class="visually-hidden">Name</label>
      <input type="text"
             placeholder="Name"
             class="form-control"
             id="name"
             formControlName="name" />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-primary"
          (click)="closeModal()">Cancel</button>
  <button class="btn btn-primary"
          [disabled]="addForm.invalid"
          (click)="add()">Create</button>
</div>